import { FC, Fragment, useState } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import EditorIcon from 'lowcode/components/EditorIcon';
import EditorTooltip from 'lowcode/components/EditorTooltip';
import IconMark from '../../components/icons/IconMark';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.teaser.EquityA');
    // 第1个列表
    const listA = [
        {
            name: t('item1_name'),
            title: t('item1_title'),
            desc: t('item1_desc'),
            btn: t('item1_btn'),
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717752049460/Coupon%20(3).png',
        },
        {
            name: t('item2_name'),
            title: t('item2_title'),
            desc: t('item2_desc'),
            btn: t('item2_btn'),
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717752081718/Coupon%20(4).png',
        },
        {
            name: t('item3_name'),
            title: t('item3_title'),
            desc: t('item3_desc'),
            btn: t('item3_btn'),
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717752026917/Coupon%20(2).png',
        },
        {
            name: t('item4_name'),
            title: t('item4_title'),
            desc: t('item4_desc'),
            btn: t('item4_btn'),
            tip: t('item4_tip'),
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717751888818/Coupon%20(1).png',
            btnLink: 'https://jp.ecoflow.com/pages/gift-card-delta-pro-3',
            hasWin: true,
            winType: 'win1',
        },
    ];
    // 第2个列表
    const listB = [
        {
            desc: t('itemb1_desc'),
            btn: t('itemb1_btn'),
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717745583417/15year_eu.png',
            hasWin: true,
            winType: 'win2',
            tip: t('win_tips2'),
        },
        {
            desc: t('itemb2_desc'),
            btn: t('itemb2_btn'),
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717745615721/paidy_logo_3x_2021%201%20(1).png',
        },
        {
            desc: t('itemb3_desc'),
            btn: t('itemb3_btn'),
            icon: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717751592395/save_money.png',
            btnLink: 'https://jp.ecoflow.com/pages/price-guarantee-delta-pro-3',
        },
        {
            desc: t('itemb4_desc'),
            btn: t('itemb3_btn'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1720169565970/%E5%9B%9E%E6%94%B6ICON.svg',
            btnLink: 'https://jp.ecoflow.com/pages/recycling-services',
        },
        // {
        //     desc: t('itemb5_desc'),
        //     icon: 'https://websiteoss.ecoflow.com/upload/image/1720169622030/QUO%20card.png',
        //     hasWin: true,
        //     winType: 'win2',
        //     tip: t('win_tips3'),
        // },
    ];

    // 弹窗
    const [visibleWin, setVisibleWin] = useState('');
    // 打开弹窗
    const openWinHandle = (type: string) => {
        setVisibleWin(type);
    };
    // 关闭弹窗
    const closeWinHandle = () => {
        setVisibleWin('');
    };
    return (
        <div className={`${css.thecomp}`}>
            <div className="comp-in comp-lista">
                {listA.map((item: any, index: number) => {
                    return (
                        <div className="comp-itema" key={index}>
                            <div className="comp-item-name">
                                {item.name}
                                {item.hasWin && (
                                    <span
                                        className="comp-icon-mark"
                                        onClick={() => {
                                            openWinHandle(item.winType);
                                        }}
                                    >
                                        <IconMark />
                                        <EditorTooltip>{t('win_tips1')}</EditorTooltip>
                                    </span>
                                )}
                            </div>
                            <div className="comp-itema-icon">
                                <EditorIcon pc={item.icon} />
                            </div>
                            <div className="text-wrapper">
                                {item.title && <div className="comp-itema-title">{item.title}</div>}
                                {item.desc && <div className="comp-itema-desc">{item.desc}</div>}
                            </div>
                            {item.btn && (
                                <EditorLink
                                    href={item.btnLink}
                                    className="comp-item-btn"
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'jump_button',
                                        position: 'Inpage',
                                        button_name: item.btn,
                                        url: item.btnLink,
                                    }}
                                >
                                    {item.btn}
                                </EditorLink>
                            )}
                            {item?.tip && <div className="comp-item-tip">{item.tip}</div>}
                        </div>
                    );
                })}
            </div>
            <div className="comp-in comp-listb-out">
                <div className="comp-listb">
                    <div className="comp-item-name">{t('itemb_name')}</div>
                    {listB.map((item: any, index: number) => {
                        return (
                            <Fragment key={index}>
                                <div className="comp-itemb">
                                    <div className="comp-itemb-icon">
                                        <EditorIcon pc={item.icon} />
                                    </div>
                                    {item.desc && <div className="comp-itemb-desc">{item.desc}</div>}
                                    {item.btn && (
                                        <EditorLink
                                            href={item.btnLink}
                                            className="comp-item-btn jp-listB-special"
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'jump_button',
                                                position: 'Inpage',
                                                button_name: item.btn,
                                                url: item.btnLink,
                                            }}
                                        >
                                            {item.btn}
                                        </EditorLink>
                                    )}
                                </div>
                                <div className="comp-itemb-split">
                                    {item.hasWin && (
                                        <span
                                            className="comp-icon-mark"
                                            onClick={() => {
                                                openWinHandle(item.winType);
                                            }}
                                        >
                                            <IconMark />
                                            <EditorTooltip>{item.tip}</EditorTooltip>
                                        </span>
                                    )}
                                </div>
                            </Fragment>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default TheComp;
